export const setReady = (discoveryId, token) => ({
  endpoint: `discovery/ready`,
  params: { discoveryId },
  method: "GET",
  headers: {
    "x-authentication-token": token,
  },
});
